import globals from '../../globlas';
import { _sendWithAxios, _sendWithAxiosBlob, _sendWithAxiosProgress } from '../api';

const REACT_APP_URL_BASE_API = globals.REACT_APP_URL_BASE_API;
const REACT_APP_URL_BASE_API_STORAGE = globals.REACT_APP_URL_BASE_API_STORAGE;

export const uploadArquivo = async (file, folder, options) => {
    const data = new FormData();
    data.append("file", file);
    return await _sendWithAxiosProgress(`${REACT_APP_URL_BASE_API}Arquivo/upload-arquivo?folder=${folder}`, 'POST', data, options);
}


export const uploadArquivos = async (files, folder, options) => {
    const data = new FormData();
    for (let i = 0; i < files.length; i++) {
        data.append(files[i].name, files[i])
    }
    return await _sendWithAxiosProgress(`${REACT_APP_URL_BASE_API}Arquivo/upload-files/${folder}`, 'POST', data, options);
}

export const uploadArquivoAzure = async (file, folder, larguraTumb, alturaTumb, options) => {
    const data = new FormData();
    data.append("file", file);

    if (!larguraTumb)
        larguraTumb = 0;

    if (!alturaTumb)
        alturaTumb = 0;

    return await _sendWithAxiosProgress(`${REACT_APP_URL_BASE_API_STORAGE}arquivo?container=centromidia&path=${folder}&larguraTumb=${larguraTumb}&alturaTumb=${alturaTumb}&geraTumb=true`, 'POST', data, options);
}

export const adicionarArquivo = async (data) => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}Arquivo/adicionar-arquivo`, 'POST', data);
}

export const detalhesArquivo = async (idArquivo) => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}Arquivo/detalhe-arquivo/${idArquivo}`, 'GET');
}

export const editarArquivo = async (data) => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}Arquivo/editar-arquivo`, 'PUT', data);
}

export const renomearArquivo = async (idUsuario, idArquivo, data) => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}Arquivo/renomear-arquivo/${idUsuario}/${idArquivo}`, 'PUT', data);
}

export const inforArquivo = async (idArquivo) => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}Arquivo/info-arquivo/${idArquivo}`, 'GET');
}

export const inativarArquivo = async (idArquivo, idUsuario) => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}Arquivo/inativar-arquivo/${idArquivo}/${idUsuario}`, 'PUT');
}

export const inativarArquivos = async (data, idUsuario) => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}Arquivo/inativar-arquivos/${idUsuario}`, 'PUT', data);
}

export const ativarArquivo = async (idUsuario, idArquivo) => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}Arquivo/ativar-arquivo/${idUsuario}/${idArquivo}`, 'PUT');
}

export const uploadImagem = async (file, larguraTumb, alturaTumb) => {
    const data = new FormData();
    data.append("arquivo", file);

    if (!larguraTumb)
        larguraTumb = 0;

    if (!alturaTumb)
        alturaTumb = 0;

    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}Arquivo/upload-arquivo?larguraTumb=${larguraTumb}&alturaTumb=${alturaTumb}`, 'POST', data);
}

export const alterarClassificacaoArquivo = async (idUsuario, idArquivo, classificacao) => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}Arquivo/alterar-classificacao/${idUsuario}/${idArquivo}/${classificacao}`, 'PUT');
}

export const moverArquivo = async (data) => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}Arquivo/mover-arquivo`, 'PUT', data);
}

export const copiarArquivo = async (copiarArquivoDto) => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}Arquivo/copiar-arquivo`, 'PUT', copiarArquivoDto);
}

export const buscarArquivosPertoDaValidade = async () => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}Arquivo/arquivos-validade`, 'GET');
}